import { RefObject } from 'react';
import { IParameterProperty } from '../../../../../../types/IParameter';
import Parameter from '../../Parameter';

class FileInput extends Parameter {
  public multipart = true;
  private inputRef: RefObject<HTMLInputElement | null> | null = null;

  constructor(parameter: IParameterProperty) {
    super(parameter);

    this.clear = this.clear.bind(this);
    this.reset = this.reset.bind(this);
    this.registerInputRef = this.registerInputRef.bind(this);
  }

  registerInputRef(inputRef: RefObject<HTMLInputElement | null>) {
    this.inputRef = inputRef;
  }

  /**
   * Need to conform to HTML standard when resetting <input type=file
   * setting this to empty string will tell the browser no file is selected.
   * Setting any other value than "" to <input type=file is not allowed
   *  -> using inputref avoids sideEffects with our model input.value when setting values value
   */
  resetInput() {
    if (this.inputRef?.current) {
      this.inputRef.current.value = '';
    }
  }

  clear(hard: boolean) {
    super.clear(hard);
    this.resetInput();
    this.broadcast();
  }

  reset() {
    super.reset();
    this.resetInput();
    this.broadcast();
  }

  /**
   * PayloadValue of type file is array as we convert FileList into array of files (see useFileUpload and FormFile).
   */
  getPayloadValue(): any {
    if (this.value && this.value.length > 0) {
      return this.value.map((currentFile: File) => {
        return { name: this.name, value: currentFile };
      });
    }

    return null;
  }
}

export default FileInput;
